import SerialNumberProvider from './SerialNumberProvider';
import SerialNumber from './SerialNumber';

let Index = () => {
    return (
        <SerialNumberProvider>
            <SerialNumber />
        </SerialNumberProvider>
    )
}

export default Index;